import m2Sidebar from "@components/sidebar/m2_sidebar";
import m1_examRegMenu from '@components/examRegMenu/m1_examRegMenu.vue'
export default {
    components: {
        "m2Sidebar": m2Sidebar,
        'examRegMenu': m1_examRegMenu
    },
    data() {
        return {
            listShow: true,
            field: {},
            examRegionGrades: [{
                index: 1,
                RegionId: null,
                showChose: true,
                chooseRegion: false,
                showRegionList: true,
                chooseRegionList: []
            }],
            regionName: ''
        }
    },
    methods: {
        getData: function () {
            this.$http.get(globalProvider.serviceUrl('e_reg/g/rgs')).then((data) => {
                if (data.body.code === resultCode.Success) {
                    this.examRegionGrades[0].chooseRegionList = data.body.data;
                }
            });
        },
        SelectedTitle: function (item) {
            item.chooseRegion = false;
            item.showRegionList = true;
            this.examRegionGrades.splice(item.index, this.examRegionGrades.length - item.index);
        },
        save() {
            if (!this.listShow) {
                this.$http.get(globalProvider.serviceUrl('e_reg/s/erb/{reg_id}/{region_code}'), {
                    params: {
                        reg_id: this.$store.state.examRegInfo.examRegInfo.exam_registration_id,
                        region_code: this.field.region_id
                    }
                }).then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.$confirm('修改考区成功', '提示', {
                            showCancelButton: false,
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.$router.push({
                                name: 'default_myRegister'
                            });
                        })
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                });
            } else this.$alert('请选择考区', {
                confirmButtonText: '确定',
            });
        },
        getRegionGradesId: function (grade, item, index) {
            if (item.children.length == 0) {
                this.examRegionGrades[grade - 1].chooseRegion = item.value;
                this.examRegionGrades[grade - 1].RegionId = item.label;
                this.listShow = false;
                let path = [];
                this.examRegionGrades.forEach((item) => {
                    path.push(item.RegionId);
                })
                this.field = {
                    region_id: item.label,
                    region_name: item.value,
                    path: path
                };
            } else {
                let thisGrade = this.examRegionGrades[grade - 1];
                let nextGrade = {
                    index: grade + 1,
                    showChose: true,
                    chooseRegion: false,
                    showRegionList: true,
                    chooseRegionList: []
                }
                thisGrade.chooseRegion = item.value;
                thisGrade.RegionId = item.label;
                thisGrade.showRegionList = false;
                nextGrade.chooseRegionList = thisGrade.chooseRegionList[index].children;
                this.examRegionGrades.push(nextGrade);
            }
        },
        regChoose: function () {
            this.listShow = true;
            this.examRegionGrades[this.examRegionGrades.length - 1].chooseRegion = false;
        },
    },
    created: function () {
        this.regionName = this.$store.state.examRegInfo.examRegInfo.region_subject_selections.region_name
        this.getData();
    }
}